import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  document.body.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:sans-serif;">
      <div style="text-align:center;">
        <p style="color:#dc2626;font-size:18px;font-weight:bold;">頁面初始化失敗</p>
        <p style="color:#666;font-size:14px;margin-top:8px;">找不到 root 元素，請聯繫技術人員。</p>
      </div>
    </div>
  `;
} else {
  try {
    const root = createRoot(rootEl);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
    // 成功載入後隱藏 loading fallback
    setTimeout(() => {
      const fallback = document.getElementById("loading-fallback");
      if (fallback) {
        fallback.classList.add("hidden");
        setTimeout(() => fallback.remove(), 350);
      }
    }, 100);
  } catch (err) {
    const msg = err instanceof Error ? err.message : "未知錯誤";
    console.error("[main.tsx] React render failed:", err);
    rootEl.innerHTML = `
      <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:sans-serif;padding:24px;">
        <div style="text-align:center;max-width:400px;">
          <p style="color:#dc2626;font-size:18px;font-weight:bold;">頁面載入發生錯誤</p>
          <p style="color:#666;font-size:14px;margin-top:8px;">請嘗試重新整理頁面，或稍後再試。</p>
          <p style="color:#b91c1c;font-size:12px;margin-top:16px;word-break:break-all;background:#fef2f2;padding:12px;border-radius:8px;">${msg}</p>
          <button onclick="window.location.reload()" style="margin-top:20px;padding:10px 24px;border-radius:9999px;border:none;background:#9f1239;color:#fff;font-size:14px;cursor:pointer;">重新整理</button>
        </div>
      </div>
    `;
  }
}